import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../utils/api';

export const fetchWishlist = createAsyncThunk('wishlist/fetch', async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.get('/wishlist');
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message);
  }
});

export const toggleWishlist = createAsyncThunk('wishlist/toggle', async (productId, { rejectWithValue }) => {
  try {
    const { data } = await API.post(`/wishlist/${productId}`);
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message);
  }
});

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: { items: [], loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWishlist.fulfilled, (state, { payload }) => {
        state.items = payload.wishlist.products || [];
      })
      .addCase(toggleWishlist.fulfilled, (state, { payload }) => {
        state.items = payload.wishlist.products || [];
      });
  },
});

export default wishlistSlice.reducer;
